const firebase = require('firebase')
require('firebase/firestore')

// initialize Firebase App
let settings = {
  apiKey: 'AIzaSyBCIclvV8Ba_Nr9B5qkxUyoRgpBTRG11tM',
  authDomain: 'ezfficient.firebaseapp.com',
  databaseURL: 'https://ezfficient.firebaseio.com',
  projectId: 'ezfficient',
  storageBucket: 'ezfficient.appspot.com',
  messagingSenderId: '23316244761',
  appId: '1:23316244761:web:7ee7023f096eabb9db7d88',
  measurementId: 'G-18ZENKFYZV'
}
firebase.initializeApp(settings)

// init zip-collages-1
var centralConfig = {
  apiKey: 'AIzaSyAh3XAZaR6pK0cB_i1EErnXeE27Yk1NVbw',
  databaseURL: 'https://ezzipcollages1.firebaseio.com',
  projectId: 'ezzipcollages1'
}
let zipCentral = firebase.initializeApp(centralConfig, 'zipCentral')
// init zip-collages-east
let eastConfig = {
  apiKey: 'AIzaSyBIhx7hLbeZ7CRS04_fAnb3Vmry5xdFs2o',
  databaseURL: 'https://ezzipcollages-east.firebaseio.com',
  projectId: 'ezzipcollages-east'
}
let zipEast = firebase.initializeApp(eastConfig, 'zipEast')
module.exports = {
  firebase,
  zipCentral,
  zipEast
}



// WEBPACK FOOTER //
// ./src/store/api/firebase.js